























































import { Vue, Component, Prop } from 'vue-property-decorator';

import { fetchListadoEjecutivos } from './fetchListadoEjecutivos';
import { LoadingService } from '@/services/loadingService';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

@Component({ components: { DatePicker } })
export default class ComponenteForm extends Vue {
  @Prop({ default: () => ({}) }) data: any;

  @Prop({ default: false }) creacion: Boolean;
  @Prop({ default: false }) edicion: Boolean;

  optionsCorreos: any = [];

  /// CAMPOS ///
  userID = JSON.parse(localStorage.getItem('user')).id;
  fechaHoy = moment();
  correo: any;
  estado: any;
  idEjecutivo: any;
  /// FIN CAMPOS ///

  loadingService = new LoadingService();
  $snotify: any;

  mounted() {
    this.getInfoCombo();
    if (this.edicion) {
      let data = this.data[0];
      this.correo = data.email;
      this.estado = data.activo;
      this.idEjecutivo = data.id;
    }
  }

  getInfoCombo() {
    this.loadingService.showLoading(undefined, 'getInfoCombo');
    this.optionsCorreos = [];
    return fetchListadoEjecutivos('getComboCorreos', {})
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.optionsCorreos = data.data.data;
        else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.optionsCorreos = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getInfoCombo'));
  }

  emitirParaGuardar() {
    let obj = {
      correo: this.correo.email
        ? this.correo.email
        : this.data[0].email
        ? this.data[0].email
        : null,
      estado: this.estado.valor
        ? this.estado.valor
        : this.data[0].activo === '🟢 Activo'
        ? 't'
        : 'f',
      fechaHoy: this.fechaHoy,
      usuarioID: this.userID,
      idEjecutivo: this.idEjecutivo ? this.idEjecutivo : null,
    };
    if (this.creacion) this.$emit('objCreacion', obj);
    if (this.edicion) this.$emit('objEdicion', obj);
  }
}
